import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TInputForm from "../../common/TInputForm";

class BusinessLicenseInfoForm extends Component {
    constructor(props) {
        super(props);

        const { agree, companyName, ceo, companyNum1, companyNum2, companyNum3, telNum1, telNum2, telNum3, companyAddr, cybermallUseTerms, commonLevier, emailpreffix, emailSuffix } = props.data.setting;
        this.state = {
            agree : agree||'0',
            companyName: companyName||'',
            ceo: ceo||'',
            companyNum1: companyNum1||'',
            companyNum2: companyNum2||'',
            companyNum3: companyNum3||'',
            telNum1: telNum1||'',
            telNum2: telNum2||'',
            telNum3: telNum3||'',
            companyAddr: companyAddr||'',
            cybermallUseTerms: cybermallUseTerms||'http://',
            commonLevier: commonLevier||'',
            emailpreffix: emailpreffix||'',
            emailSuffix: emailSuffix||'',
        };

    }

    componentDidMount() {
        const { plugin, onChange } = this.props
        const pluginData = this.generatePluginData();
        pluginData['validated'] = false
        onChange(pluginData);
    }

    @autobind
    changePluginData() {
        const { onChange } = this.props;
        const pluginData = this.generatePluginData();
        onChange(pluginData);
    }

    @autobind
    generatePluginData() {
        let pluginData = Object.assign({},this.state)
        let validate = this.checkValidation(pluginData);
        return {
            setting : pluginData,
            validated: validate
        };
    }

    checkValidation(data) {
        let validate = true;
        const { agree, companyName, ceo, companyNum1, companyNum2, companyNum3, telNum1, telNum2, telNum3, companyAddr, cybermallUseTerms } = data;
        if(agree != '1') validate = false;
        if(companyName.length === 0) validate = false;
        if(ceo.length === 0) validate = false;
        if(companyNum1.length === 0) validate = false;
        if(companyNum2.length === 0) validate = false;
        if(companyNum3.length === 0) validate = false;
        if(telNum1.length === 0) validate = false;
        if(telNum2.length === 0) validate = false;
        if(telNum3.length === 0) validate = false;
        if(companyAddr.length === 0) validate = false;
        if(cybermallUseTerms.length === 0) validate = false;
        return validate;
    }

    @autobind
    handleChange(value, property) {
        this.setState(
            Object.assign(this.state,  {
                [property]: value
            })
        );

        this.changePluginData();
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin30">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_plugin">
                    <div className="box_plugin">
                        <p>사업자 정보 표시 플러그인을 설정하기 위해서는 개인정보 수집 동의가 필요합니다.</p>
                        <ul className="list_info">
                            <li>목적 : 통신판매업자의 사업자 정보 표시를 위한 정보 수집</li>
                            <li>항목 : 대표자 성명, 사업장 주소, 전화번호, 전자우편 주소</li>
                            <li>보유 및 이용기간 : 플러그인 설정 해지 시, 지체 없이 파기</li>
                        </ul>
                        <p>
                            개인정보 수집 동의를 거부하실 수 있으며 다만 이 경우 플러그인 사용이 제한됩니다.
                            그 밖의 사항은 개인정보취급방침(https://www.tistory.com/info/privacy)을 준수합니다.
                        </p>
                    </div>
                    <div className="check_blog">
                        <input type="checkbox" id="inpCheck1" className="inp_check" defaultChecked={this.props.data.setting.agree == "1"} onChange={(value)=>this.handleChange((this.props.data.setting.agree=='1'?'0':'1')+"",'agree')}/>
                        <label htmlFor="inpCheck1" className="lab_check">
                            <span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
                            <span className="txt_check">개인정보 수집 및 이용에 동의합니다.</span>
                        </label>
                    </div>
                </div>
                <fieldset>
                    <legend className="tit_set">필수 입력</legend>
                    <dl className="list_write">
                        <dt>상호명</dt>
                        <dd className="follow_write">
                            <TInputForm type="text" className="tf_set tf_set232" value={this.props.data.setting.companyName} title="상호명 입력" onChange={(value)=>this.handleChange(value,'companyName')} />
                        </dd>
                        <dt>대표자 성명</dt>
                        <dd>
                            <TInputForm type="text" className="tf_set tf_set232" value={this.props.data.setting.ceo} title="대표자 성명 입력" onChange={(value)=>this.handleChange(value,'ceo')} />
                        </dd>
                        <dt>사업자등록번호</dt>
                        <dd className="follow_write">
                            <TInputForm type="text" className="tf_set tf_set60" value={this.props.data.setting.companyNum1} title="사업자등록번호 앞 3자리 입력" onChange={(value)=>this.handleChange(value,'companyNum1')} />
                            <span className="txt_write">-</span>
                            <TInputForm type="text" className="tf_set tf_set50" title="사업자등록번호 가운데 2자리 입력" value={this.props.data.setting.companyNum2} onChange={(value)=>this.handleChange(value,'companyNum2')}/>
                            <span className="txt_write">-</span>
                            <TInputForm type="text" className="tf_set tf_set92" title="사업자등록번호 마지막 5자리 입력" value={this.props.data.setting.companyNum3} onChange={(value)=>this.handleChange(value,'companyNum3')} />
                        </dd>
                        <dt>전화번호</dt>
                        <dd>
                            <TInputForm type="text" className="tf_set tf_set60" title="전화번호 앞 3자리 입력" value={this.props.data.setting.telNum1} onChange={(value)=>this.handleChange(value,'telNum1')}/>
                            <span className="txt_write">-</span>
                            <TInputForm type="text" className="tf_set tf_set60" title="전화번호 가운데 부분 입력" value={this.props.data.setting.telNum2} onChange={(value)=>this.handleChange(value,'telNum2')} />
                            <span className="txt_write">-</span>
                            <TInputForm type="text" className="tf_set tf_set82" title="전화번호 마지막 4자리 입력" value={this.props.data.setting.telNum3} onChange={(value)=>this.handleChange(value,'telNum3')} />
                        </dd>
                        <dt>사업장 주소</dt>
                        <dd>
                            <TInputForm type="text" className="tf_set tf_set600" title="사업장 주소 입력" value={this.props.data.setting.companyAddr} onChange={(value)=>this.handleChange(value,'companyAddr')}/>
                        </dd>
                        <dt>사이버몰 이용약관</dt>
                        <dd>
                            <TInputForm type="text" className="tf_set tf_set600" title="사이버몰 이용약관 입력" value={this.props.data.setting.cybermallUseTerms} value={this.props.data.setting.cybermallUseTerms} onChange={(value)=>this.handleChange(value,'cybermallUseTerms')} placeholder="http://" />
                        </dd>
                        <dt>통신판매신고번호</dt>
                        <dd>
                            <TInputForm type="text" className="tf_set tf_set232" title="통신판매신고번호 입력"  value={this.props.data.setting.commonLevier} onChange={(value)=>this.handleChange(value,'commonLevier')}/>
                            <span className="txt_write type_text">호</span>
                        </dd>
                    </dl>
                    <p className="txt_other">
                        통신판매신고 번호를 공정거래위원회에서 받으셨다면 입력해 주세요.<br />
                        단, 최근 6개월 동안 통신판매의 거래 횟수가 20회 미만이거나 최근 6개월 동안 통신판매 거래 규모가 1,200 만원 미만인 경우에는 입력하지 않으셔도 됩니다.
                    </p>
                </fieldset>
                <fieldset>
                    <legend className="tit_set">선택입력</legend>
                    <dl className="list_write">
                        <dt>전자우편</dt>
                        <dd>
                            <TInputForm type="text" className="tf_set tf_set160" title="전자우편 주소 앞부분 입력"  value={this.props.data.setting.emailpreffix} onChange={(value)=>this.handleChange(value,'emailpreffix')}/>
                            <span className="txt_write type_text">@</span>
                            <TInputForm type="text" className="tf_set tf_set160" title="전자우편 주소 뒷부분(도메인) 입력"  value={this.props.data.setting.emailSuffix} onChange={(value)=>this.handleChange(value,'emailSuffix')}/>
                        </dd>
                    </dl>
                </fieldset>
                {this.props.saveButton()}
            </div>
        )
    }
}

BusinessLicenseInfoForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default BusinessLicenseInfoForm
